import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const NghiLuanXaHoiPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        {/* Breadcrumbs */}
        <div className="max-w-5xl mx-auto px-6 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-red-600 transition-colors">Trang chủ</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/van" className="hover:text-red-600 transition-colors">Văn học</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">Nghị luận xã hội</span>
          </div>
        </div>

        {/* Article Header */}
        <article className="max-w-5xl mx-auto px-6">
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Merriweather, serif' }}>
              Hướng Dẫn Viết Bài Văn Nghị Luận Xã Hội Đạt Điểm Cao
            </h1>
            
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-6">
              <span className="bg-red-100 text-red-700 px-3 py-1.5 rounded-full font-medium">
                <i className="ri-book-open-line mr-1"></i>
                Văn học lớp 11-12
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                18 phút đọc
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line"></i>
                25,890 lượt xem
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-folder-line"></i>
                Kỹ năng viết
              </span>
            </div>

            <div className="h-96 rounded-2xl overflow-hidden mb-8">
              <img 
                src="https://public.readdy.ai/ai/img_res/2abefba1e1c95ff8d985fce36ae7b5d5.jpg"
                alt="Nghị luận xã hội"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Table of Contents */}
          <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-2xl p-8 mb-12 border border-red-100">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-list-check text-red-600"></i>
              Mục lục
            </h3>
            <ul className="space-y-2.5">
              <li>
                <a href="#overview" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>1. Văn nghị luận xã hội là gì?</span>
                </a>
              </li>
              <li>
                <a href="#structure" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>2. Cấu trúc bài văn nghị luận xã hội</span>
                </a>
              </li>
              <li>
                <a href="#introduction" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>3. Cách viết phần mở bài</span>
                </a>
              </li>
              <li>
                <a href="#body" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>4. Cách viết phần thân bài</span>
                </a>
              </li>
              <li>
                <a href="#conclusion" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>5. Cách viết phần kết bài</span>
                </a>
              </li>
              <li>
                <a href="#tips" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>6. Mẹo và kỹ thuật nâng cao</span>
                </a>
              </li>
              <li>
                <a href="#examples" className="text-gray-700 hover:text-red-600 transition-colors flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-red-500"></i>
                  <span>7. Bài văn mẫu tham khảo</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Section 1: Overview */}
          <section id="overview" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              1. Văn Nghị Luận Xã Hội Là Gì?
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-xl mb-6">
                <p className="text-gray-800 font-medium leading-relaxed">
                  <strong>Văn nghị luận xã hội</strong> là loại văn bản dùng để phân tích, đánh giá, bình luận về một hiện tượng, vấn đề xã hội nhằm đưa ra quan điểm, thái độ của người viết và thuyết phục người đọc.
                </p>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4">1.1. Đặc điểm của văn nghị luận xã hội</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Văn nghị luận xã hội có những đặc điểm riêng biệt so với các thể loại văn bản khác:
              </p>

              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <i className="ri-focus-line text-red-600"></i>
                    Đối tượng nghị luận
                  </h4>
                  <p className="text-gray-700 text-sm">
                    Các vấn đề, hiện tượng xã hội có tính thời sự, gắn liền với đời sống con người như: giáo dục, môi trường, văn hóa, đạo đức...
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <i className="ri-pen-nib-line text-red-600"></i>
                    Mục đích
                  </h4>
                  <p className="text-gray-700 text-sm">
                    Phân tích, đánh giá vấn đề, thể hiện quan điểm cá nhân và thuyết phục người đọc chấp nhận quan điểm đó.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <i className="ri-discuss-line text-red-600"></i>
                    Phương pháp nghị luận
                  </h4>
                  <p className="text-gray-700 text-sm">
                    Sử dụng lý lẽ, dẫn chứng, phân tích, so sánh, đối chiếu để chứng minh quan điểm của mình.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <i className="ri-text text-red-600"></i>
                    Ngôn ngữ
                  </h4>
                  <p className="text-gray-700 text-sm">
                    Chính xác, logic, có tính thuyết phục cao. Sử dụng các từ nối, liên kết để tạo mạch văn chặt chẽ.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">1.2. Phân biệt với nghị luận văn học</h3>
              <div className="overflow-x-auto mb-6">
                <table className="w-full border-collapse bg-white rounded-xl overflow-hidden shadow-sm">
                  <thead>
                    <tr className="bg-gradient-to-r from-red-600 to-pink-600 text-white">
                      <th className="border border-red-300 px-4 py-3 text-left">Tiêu chí</th>
                      <th className="border border-red-300 px-4 py-3 text-left">Nghị luận xã hội</th>
                      <th className="border border-red-300 px-4 py-3 text-left">Nghị luận văn học</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="hover:bg-red-50 transition-colors">
                      <td className="border border-gray-200 px-4 py-3 font-medium">Đối tượng</td>
                      <td className="border border-gray-200 px-4 py-3">Hiện tượng, vấn đề xã hội</td>
                      <td className="border border-gray-200 px-4 py-3">Tác phẩm văn học, nghệ thuật</td>
                    </tr>
                    <tr className="hover:bg-red-50 transition-colors">
                      <td className="border border-gray-200 px-4 py-3 font-medium">Dẫn chứng</td>
                      <td className="border border-gray-200 px-4 py-3">Sự kiện thực tế, số liệu, ví dụ đời sống</td>
                      <td className="border border-gray-200 px-4 py-3">Trích dẫn từ tác phẩm, phân tích nhân vật</td>
                    </tr>
                    <tr className="hover:bg-red-50 transition-colors">
                      <td className="border border-gray-200 px-4 py-3 font-medium">Mục đích</td>
                      <td className="border border-gray-200 px-4 py-3">Nhận thức và giải quyết vấn đề xã hội</td>
                      <td className="border border-gray-200 px-4 py-3">Thẩm mỹ, đánh giá giá trị nghệ thuật</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* Section 2: Structure */}
          <section id="structure" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              2. Cấu Trúc Bài Văn Nghị Luận Xã Hội
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                Một bài văn nghị luận xã hội chuẩn thường có cấu trúc 3 phần: Mở bài - Thân bài - Kết bài. Mỗi phần có vai trò và cách viết riêng.
              </p>

              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold">1</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold mb-2">Mở bài (10-15% bài viết)</h3>
                      <p className="opacity-90">
                        Giới thiệu vấn đề, đặt vấn đề nghị luận, nêu luận điểm chính. Phần này cần ngắn gọn, súc tích nhưng đủ thu hút người đọc.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold">2</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold mb-2">Thân bài (70-80% bài viết)</h3>
                      <p className="opacity-90">
                        Phần quan trọng nhất, triển khai luận điểm với các luận cứ, dẫn chứng cụ thể. Phân tích, lý giải, đánh giá vấn đề một cách có hệ thống và logic.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-red-600 to-pink-600 text-white rounded-xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold">3</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold mb-2">Kết bài (10-15% bài viết)</h3>
                      <p className="opacity-90">
                        Khẳng định lại luận điểm, tổng kết vấn đề, mở rộng ý nghĩa. Có thể đề xuất giải pháp hoặc kêu gọi hành động.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 3: Introduction */}
          <section id="introduction" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              3. Cách Viết Phần Mở Bài
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                Mở bài là phần đầu tiên người đọc tiếp xúc, do đó cần được viết hấp dẫn, thu hút. Một mở bài tốt sẽ quyết định người đọc có tiếp tục đọc hay không.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mb-4">3.1. Các cách mở bài hiệu quả</h3>
              
              <div className="space-y-4 mb-6">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-xl border-l-4 border-amber-500">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-question-line text-amber-600"></i>
                    Cách 1: Đặt câu hỏi gợi mở
                  </h4>
                  <p className="text-gray-700 mb-3">
                    Bắt đầu bằng một hoặc nhiều câu hỏi liên quan đến vấn đề, kích thích sự tò mò của người đọc.
                  </p>
                  <div className="bg-white p-4 rounded-lg border border-amber-200">
                    <p className="text-gray-700 italic">
                      <strong>Ví dụ:</strong> "Tại sao ngày nay nhiều bạn trẻ lại dành quá nhiều thời gian cho mạng xã hội? Liệu điều này có ảnh hưởng đến cuộc sống thực của họ?"
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-xl border-l-4 border-blue-500">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-quote-text text-blue-600"></i>
                    Cách 2: Dẫn câu ca dao, tục ngữ, danh ngôn
                  </h4>
                  <p className="text-gray-700 mb-3">
                    Sử dụng những câu nói nổi tiếng có liên quan để tạo độ tin cậy và sức thuyết phục.
                  </p>
                  <div className="bg-white p-4 rounded-lg border border-blue-200">
                    <p className="text-gray-700 italic">
                      <strong>Ví dụ:</strong> "Bác Hồ từng dạy: 'Vì lợi ích mười năm thì phải trồng cây, vì lợi ích trăm năm thì phải trồng người.' Câu nói ấy luôn đúng với giáo dục..."
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border-l-4 border-green-500">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-newspaper-line text-green-600"></i>
                    Cách 3: Dẫn sự kiện thời sự
                  </h4>
                  <p className="text-gray-700 mb-3">
                    Nêu một sự kiện có thật đang được quan tâm để dẫn dắt vào vấn đề.
                  </p>
                  <div className="bg-white p-4 rounded-lg border border-green-200">
                    <p className="text-gray-700 italic">
                      <strong>Ví dụ:</strong> "Gần đây, một clip học sinh bạo lực học đường đã gây xôn xao dư luận. Vấn đề này đặt ra câu hỏi về giáo dục đạo đức trong nhà trường..."
                    </p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border-l-4 border-purple-500">
                  <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-line-chart-line text-purple-600"></i>
                    Cách 4: Nêu hiện trạng vấn đề
                  </h4>
                  <p className="text-gray-700 mb-3">
                    Mô tả tình hình hiện tại của vấn đề để người đọc nhận thức rõ tầm quan trọng.
                  </p>
                  <div className="bg-white p-4 rounded-lg border border-purple-200">
                    <p className="text-gray-700 italic">
                      <strong>Ví dụ:</strong> "Ô nhiễm môi trường đang là vấn đề toàn cầu. Tại Việt Nam, tình trạng rác thải nhựa ngày càng trầm trọng..."
                    </p>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">3.2. Những điều cần tránh khi viết mở bài</h3>
              <div className="bg-red-50 border border-red-200 rounded-xl p-6">
                <ul className="space-y-2.5 text-gray-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-600 flex-shrink-0 mt-1"></i>
                    <span>Mở bài quá dài, lan man, không đi vào trọng tâm</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-600 flex-shrink-0 mt-1"></i>
                    <span>Nêu quá nhiều vấn đề khiến bài văn mất trọng tâm</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-600 flex-shrink-0 mt-1"></i>
                    <span>Sử dụng câu văn sáo rỗng, thiếu tính thực tế</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-line text-red-600 flex-shrink-0 mt-1"></i>
                    <span>Không nêu rõ luận điểm chính của bài viết</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 4: Body */}
          <section id="body" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              4. Cách Viết Phần Thân Bài
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                Thân bài là phần chiếm nhiều dung lượng và quan trọng nhất. Đây là nơi bạn triển khai luận điểm, chứng minh quan điểm của mình bằng các luận cứ và dẫn chứng cụ thể.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mb-4">4.1. Cấu trúc thân bài</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Thân bài nên được chia thành nhiều đoạn văn, mỗi đoạn tập trung phân tích một khía cạnh của vấn đề. Cấu trúc thông thường:
              </p>

              <div className="bg-gradient-to-br from-red-50 to-pink-50 p-6 rounded-xl mb-6 border border-red-100">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">1</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Luận điểm phụ 1</h4>
                      <p className="text-gray-700 text-sm">→ Luận cứ + Dẫn chứng + Phân tích</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">2</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Luận điểm phụ 2</h4>
                      <p className="text-gray-700 text-sm">→ Luận cứ + Dẫn chứng + Phân tích</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">3</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Luận điểm phụ 3</h4>
                      <p className="text-gray-700 text-sm">→ Luận cứ + Dẫn chứng + Phân tích</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">4.2. Các loại dẫn chứng thuyết phục</h3>
              
              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="bg-white p-5 rounded-xl border-2 border-red-200 hover:border-red-400 transition-colors">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                      <i className="ri-history-line text-red-600 text-xl"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Dẫn chứng lịch sử</h4>
                  </div>
                  <p className="text-gray-700 text-sm">
                    Các sự kiện, nhân vật lịch sử điển hình minh họa cho vấn đề đang bàn.
                  </p>
                </div>

                <div className="bg-white p-5 rounded-xl border-2 border-red-200 hover:border-red-400 transition-colors">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                      <i className="ri-user-heart-line text-red-600 text-xl"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Dẫn chứng thực tế</h4>
                  </div>
                  <p className="text-gray-700 text-sm">
                    Những ví dụ cụ thể trong đời sống xã hội hiện tại, có thể là sự kiện gần đây.
                  </p>
                </div>

                <div className="bg-white p-5 rounded-xl border-2 border-red-200 hover:border-red-400 transition-colors">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                      <i className="ri-book-open-line text-red-600 text-xl"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Dẫn chứng văn học</h4>
                  </div>
                  <p className="text-gray-700 text-sm">
                    Nhân vật, sự kiện trong tác phẩm văn học minh họa cho vấn đề xã hội.
                  </p>
                </div>

                <div className="bg-white p-5 rounded-xl border-2 border-red-200 hover:border-red-400 transition-colors">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                      <i className="ri-user-line text-red-600 text-xl"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Dẫn chứng cá nhân</h4>
                  </div>
                  <p className="text-gray-700 text-sm">
                    Trải nghiệm, quan sát của bản thân về vấn đề đang bàn.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">4.3. Cách triển khai một đoạn văn</h3>
              <div className="bg-white p-6 rounded-xl border-2 border-gray-200 mb-6">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-600 text-white rounded flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">1</div>
                    <div className="flex-1">
                      <p className="font-bold text-gray-900 mb-1">Nêu luận điểm phụ</p>
                      <p className="text-gray-600 text-sm italic">
                        "Trước hết, đọc sách giúp mở rộng kiến thức và phát triển tư duy."
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-600 text-white rounded flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">2</div>
                    <div className="flex-1">
                      <p className="font-bold text-gray-900 mb-1">Đưa ra luận cứ</p>
                      <p className="text-gray-600 text-sm italic">
                        "Sách là kho tàng tri thức nhân loại, mỗi quyển sách là một thế giới kiến thức mới mẻ..."
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-600 text-white rounded flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">3</div>
                    <div className="flex-1">
                      <p className="font-bold text-gray-900 mb-1">Dẫn chứng cụ thể</p>
                      <p className="text-gray-600 text-sm italic">
                        "Bill Gates - tỷ phú công nghệ - từng chia sẻ rằng ông đọc 50 cuốn sách mỗi năm..."
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-600 text-white rounded flex items-center justify-center flex-shrink-0 text-sm font-bold mt-1">4</div>
                    <div className="flex-1">
                      <p className="font-bold text-gray-900 mb-1">Phân tích, lý giải</p>
                      <p className="text-gray-600 text-sm italic">
                        "Như vậy, việc đọc sách không chỉ giúp ta có kiến thức mà còn rèn luyện khả năng tư duy..."
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">4.4. Các từ nối quan trọng</h3>
              <div className="grid md:grid-cols-3 gap-3">
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Liệt kê:</p>
                  <p className="text-gray-700 text-sm">Trước hết, Thứ hai, Thứ ba, Cuối cùng, Ngoài ra...</p>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Bổ sung:</p>
                  <p className="text-gray-700 text-sm">Hơn nữa, Không những... mà còn..., Thêm vào đó...</p>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Đối lập:</p>
                  <p className="text-gray-700 text-sm">Tuy nhiên, Ngược lại, Mặt khác, Song...</p>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Nhấn mạnh:</p>
                  <p className="text-gray-700 text-sm">Đặc biệt, Quan trọng hơn cả, Điều đáng chú ý...</p>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Kết quả:</p>
                  <p className="text-gray-700 text-sm">Do đó, Vì vậy, Chính vì thế, Như vậy...</p>
                </div>
                <div className="bg-gradient-to-br from-red-50 to-pink-50 p-4 rounded-lg">
                  <p className="font-bold text-gray-900 mb-2 text-sm">Minh họa:</p>
                  <p className="text-gray-700 text-sm">Ví dụ, Chẳng hạn, Cụ thể là...</p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 5: Conclusion */}
          <section id="conclusion" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              5. Cách Viết Phần Kết Bài
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                Kết bài là phần kết thúc bài viết, tạo ấn tượng cuối cùng với người đọc. Một kết bài hay sẽ giúp bài văn trọn vẹn và có sức thuyết phục cao.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mb-4">5.1. Nội dung kết bài cần có</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3 bg-red-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-red-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">Khẳng định lại luận điểm</p>
                    <p className="text-gray-700 text-sm">Nhắc lại quan điểm chính của bài viết một cách ngắn gọn, rõ ràng.</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-red-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-red-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">Tổng kết vấn đề</p>
                    <p className="text-gray-700 text-sm">Nhấn mạnh những điểm quan trọng đã phân tích trong thân bài.</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-red-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-red-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">Mở rộng ý nghĩa</p>
                    <p className="text-gray-700 text-sm">Liên hệ vấn đề với bối cảnh rộng hơn, ý nghĩa sâu xa hơn.</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-red-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-red-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">Đề xuất hành động (nếu cần)</p>
                    <p className="text-gray-700 text-sm">Gợi ý giải pháp hoặc kêu gọi người đọc hành động.</p>
                  </div>
                </div>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-4 mt-8">5.2. Các cách kết bài ấn tượng</h3>
              <div className="space-y-4">
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-5 rounded-xl border-l-4 border-purple-500">
                  <h4 className="font-bold text-gray-900 mb-2">• Kết bài bằng câu hỏi tu từ</h4>
                  <p className="text-gray-700 text-sm italic">
                    "Chúng ta có thể phát triển bền vững nếu không bảo vệ môi trường?"
                  </p>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-5 rounded-xl border-l-4 border-blue-500">
                  <h4 className="font-bold text-gray-900 mb-2">• Kết bài bằng lời kêu gọi</h4>
                  <p className="text-gray-700 text-sm italic">
                    "Hãy cùng nhau hành động ngay hôm nay để bảo vệ hành tinh xanh của chúng ta!"
                  </p>
                </div>

                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-5 rounded-xl border-l-4 border-green-500">
                  <h4 className="font-bold text-gray-900 mb-2">• Kết bài bằng triển vọng tương lai</h4>
                  <p className="text-gray-700 text-sm italic">
                    "Tin rằng với nỗ lực chung, một xã hội văn minh, hiện đại sẽ không còn xa."
                  </p>
                </div>

                <div className="bg-gradient-to-r from-amber-50 to-orange-50 p-5 rounded-xl border-l-4 border-amber-500">
                  <h4 className="font-bold text-gray-900 mb-2">• Kết bài bằng danh ngôn, câu ca dao</h4>
                  <p className="text-gray-700 text-sm italic">
                    "Như Ngạn ngữ Việt Nam đã nói: 'Ăn quả nhớ kẻ trồng cây' - lòng biết ơn luôn là đức tính cao đẹp."
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 6: Tips */}
          <section id="tips" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              6. Mẹo Và Kỹ Thuật Nâng Cao
            </h2>
            
            <div className="prose prose-lg max-w-none">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-red-600 to-pink-600 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-lightbulb-flash-line text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Lập dàn ý trước khi viết</h3>
                  <p className="text-white/90 text-sm">
                    Dàn ý giúp bài viết có cấu trúc rõ ràng, logic chặt chẽ. Nên dành 10-15 phút để lập dàn ý chi tiết.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-amber-500 to-orange-500 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-bar-chart-line text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Sử dụng số liệu, thống kê</h3>
                  <p className="text-white/90 text-sm">
                    Số liệu cụ thể tăng tính thuyết phục. VD: "90% học sinh thừa nhận..." tốt hơn "Nhiều học sinh..."
                  </p>
                </div>

                <div className="bg-gradient-to-br from-blue-500 to-cyan-500 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-contrast-line text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Đưa ra quan điểm đối lập</h3>
                  <p className="text-white/90 text-sm">
                    Nêu quan điểm ngược lại rồi bác bỏ sẽ làm bài văn thuyết phục hơn, thể hiện tư duy biện chứng.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-green-500 to-emerald-500 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-translate-2 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Sử dụng ngôn từ đa dạng</h3>
                  <p className="text-white/90 text-sm">
                    Tránh lặp từ, dùng từ đồng nghĩa. VD: quan trọng → thiết yếu, cần thiết, then chốt...
                  </p>
                </div>

                <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-file-edit-line text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Kiểm tra và chỉnh sửa</h3>
                  <p className="text-white/90 text-sm">
                    Sau khi viết xong, đọc lại toàn bài để sửa lỗi chính tả, ngữ pháp, logic. Bài hay cần được chỉnh sửa nhiều lần.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-indigo-500 to-blue-500 text-white p-6 rounded-2xl">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-character-recognition-line text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Viết câu văn ngắn gọn</h3>
                  <p className="text-white/90 text-sm">
                    Câu văn quá dài dễ rối. Mỗi câu nên có 15-25 từ, tập trung vào một ý chính.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 7: Example */}
          <section id="examples" className="mb-12 scroll-mt-24">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Merriweather, serif' }}>
              7. Bài Văn Mẫu Tham Khảo
            </h2>
            
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-2xl border border-gray-200">
              <h3 className="text-2xl font-bold text-red-600 mb-6 text-center">
                Văn hóa đọc của giới trẻ hiện nay
              </h3>
              
              <div className="prose prose-lg max-w-none space-y-4 text-gray-700">
                <p className="leading-relaxed">
                  <strong className="text-gray-900">Mở bài:</strong> Trong thời đại công nghệ số phát triển như vũ bão, thói quen đọc sách của giới trẻ đang có những thay đổi đáng kể. Nhiều người lo ngại rằng thế hệ trẻ ngày nay không còn yêu thích đọc sách giấy như trước. Vậy thực tế văn hóa đọc của giới trẻ hiện nay như thế nào và chúng ta cần làm gì để khơi dậy niềm đam mê đọc sách?
                </p>

                <p className="leading-relaxed">
                  <strong className="text-gray-900">Thân bài:</strong> Trước hết, phải thừa nhận rằng văn hóa đọc của giới trẻ đang chuyển dịch từ sách giấy sang sách điện tử và các nội dung số. Theo khảo sát của Viện Nghiên cứu Văn hóa năm 2023, 75% thanh thiếu niên thích đọc trên điện thoại và máy tính bảng hơn là sách giấy. Điều này không có nghĩa họ không đọc, mà cách thức đọc đã thay đổi. Các ứng dụng như Wattpad, fanpage văn học, podcast sách nói... đều thu hút hàng triệu bạn trẻ theo dõi.
                </p>

                <p className="leading-relaxed">
                  Thứ hai, nội dung đọc của giới trẻ cũng đa dạng và phong phú hơn. Không chỉ dừng lại ở văn học kinh điển, các bạn còn quan tâm đến sách kỹ năng sống, tâm lý học, khoa học công nghệ, truyện tranh Nhật Bản... Điều này cho thấy thế hệ trẻ có nhu cầu tiếp cận tri thức đa chiều, phục vụ cho sự phát triển toàn diện. Ví dụ, cuốn "Tuổi trẻ đáng giá bao nhiêu" của tác giả Rosie Nguyễn đã bán được hơn 300.000 bản, chứng tỏ giới trẻ rất quan tâm đến sách self-help.
                </p>

                <p className="leading-relaxed">
                  Tuy nhiên, không thể phủ nhận rằng văn hóa đọc sâu đang bị đe dọa. Nhiều bạn trẻ chỉ đọc lướt qua các bài viết ngắn trên mạng xã hội, thiếu kiên nhẫn với những cuốn sách dày. Sự phân tâm từ điện thoại, game, TikTok... khiến thời gian đọc sách bị rút ngắn đáng kể. Điều này ảnh hưởng đến khả năng tập trung, tư duy phản biện và sự thấu hiểu sâu sắc.
                </p>

                <p className="leading-relaxed">
                  <strong className="text-gray-900">Kết bài:</strong> Như vậy, văn hóa đọc của giới trẻ hiện nay đang trong giai đoạn chuyển đổi, không phải suy thoái hoàn toàn. Nhiệm vụ của gia đình, nhà trường và xã hội là định hướng, khuyến khích thói quen đọc đúng đắn, giúp thế hệ trẻ tiếp cận tri thức một cách có chọn lọc và hiệu quả. Bởi lẽ, như Francis Bacon đã nói: "Đọc sách làm cho con người trở nên đầy đặn" - điều này vẫn còn nguyên giá trị trong thời đại số.
                </p>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-300">
                <p className="text-sm text-gray-600 italic">
                  <i className="ri-information-line text-red-600 mr-1"></i>
                  Bài văn mẫu này thể hiện đầy đủ cấu trúc 3 phần, sử dụng dẫn chứng cụ thể, số liệu, và có quan điểm rõ ràng.
                </p>
              </div>
            </div>
          </section>

          {/* Summary */}
          <section className="mb-12">
            <div className="bg-gradient-to-br from-red-600 to-pink-600 text-white rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6 flex items-center gap-2">
                <i className="ri-bookmark-line"></i>
                Tổng Kết - Checklist Hoàn Thiện Bài Văn
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-2.5">
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Mở bài hấp dẫn, nêu rõ vấn đề và luận điểm</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Thân bài có ít nhất 2-3 luận điểm phụ</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Mỗi luận điểm có luận cứ và dẫn chứng cụ thể</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Sử dụng từ nối để tạo mạch văn logic</span>
                  </div>
                </div>
                <div className="space-y-2.5">
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Kết bài tổng kết và mở rộng ý nghĩa</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Ngôn ngữ chính xác, không lỗi chính tả</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Câu văn ngắn gọn, dễ hiểu, không rườm rà</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Bài viết đạt yêu cầu về số lượng từ</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Related Lessons */}
          <div className="mt-16 pt-12 border-t border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Bài học liên quan</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Link to="/van/phan-tich-bai-tho-viet-bac" className="group bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl hover:shadow-lg transition-all border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <i className="ri-book-2-line text-white text-xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-900 mb-1 group-hover:text-red-600 transition-colors">Phân tích bài thơ Việt Bắc</h4>
                    <p className="text-sm text-gray-600">Hướng dẫn phân tích chi tiết tác phẩm Tố Hữu</p>
                  </div>
                  <i className="ri-arrow-right-line text-gray-400 group-hover:text-red-600 group-hover:translate-x-1 transition-all"></i>
                </div>
              </Link>

              <Link to="/van/van-ban-nghi-luan-van-hoc" className="group bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl hover:shadow-lg transition-all border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <i className="ri-article-line text-white text-xl"></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-gray-900 mb-1 group-hover:text-red-600 transition-colors">Văn bản nghị luận văn học</h4>
                    <p className="text-sm text-gray-600">Kỹ năng viết bài nghị luận về tác phẩm văn học</p>
                  </div>
                  <i className="ri-arrow-right-line text-gray-400 group-hover:text-red-600 group-hover:translate-x-1 transition-all"></i>
                </div>
              </Link>
            </div>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default NghiLuanXaHoiPage;